import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-iqac-members',
  templateUrl: './iqac-members.component.html',
  styleUrls: ['./iqac-members.component.scss']
})
export class IqacMembersComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
